import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import * as yup from "yup";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import CustomInput from "../../../common/components/CustomInput";
import { getAllergies } from "../services/EMRServices/emrServices";
import { DeleteIcon } from "./EmrCommonAsset/Asset";
import AllergiesModal from "./AllergiesModal";
export default function Allergies(props) {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  const {
    allergiesData,
    setAllergiesData,
    dataAllergies,
    setDataAllergies,
    markFavoriteData,
  } = props;
  const [save, setSave] = useState(false);

  const validationSchema = yup.object().shape({
    allergyDescription: yup.string().required("Required"),
    allergyType: yup
      .object()
      .nullable()
      .shape({
        value: yup.string(),
        label: yup.string(),
      })
      .required("Please Select Allergies Type"),
  });
  const [allAllergiesChipsList, setAllAllergiesChipsList] = useState([]);
  const [allergiesChipsList, setAllergiesChipsList] = useState([]);

  const [selectedAllergie, setSelectedAllergie] = useState(null);
  const [selectedAllergieDecription, setSelectedAllergieDescription] =
    useState("");
  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);
  const [openAllergiesModal, setOpenAllergiesModal] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [allergiesTypeList, setAllergiesTypeList] = useState();
  //  const [ allergiesValue,setAllergiesValue]=useState(null)

  const handleChange = (e) => {
    if (e.length > 0) {
      if (UseCheckConsecutiveCharacters(e)) {
        getAllergies(e)
          .then((response) => {
            setAllergiesTypeList(response.data.result);
          })
          .catch((response) => {
            console.log(response);
          });
      }
    } else if (e === "" || e === undefined || e === null) {
      setAllergiesTypeList([]);
    }
  };

  function deleteRow(index) {
    const newComplaintsData = [...allergiesData];
    newComplaintsData.splice(index, 1);
    // setRadiologyData(newComplaintsData);
    setAllergiesData(newComplaintsData);
    // setDataAllergies(newComplaintsData);
  }
  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              setEditOpen(true);
              setEdit(true);
              setRow(row);
              setIndex(index);
              // setSave(false)
            }}
          >
            <EditIcon />
          </button>
        </Tooltip> */}

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  useEffect(() => {
    if (save === true) {
      setAllergiesData([...dataAllergies]);
      setSave(false);
    }
  }, [save]);
  let allergyType = watch("allergyType");
  let description = watch("description");

  useEffect(() => {
    if (
      allergyType !== null &&
      allergyType !== undefined &&
      allergyType !== ""
    ) {
      let obj = {
        allergy: allergyType?.label,
        description: description,
        isNew:
          allergyType?.__isNew__ !== undefined &&
          allergyType?.__isNew__ === true
            ? true
            : false,
      };
      let temp = allergiesData.some(
        (item) => item.allergy === allergyType?.label
      );

      if (temp === true) {
        warningAlert("Already Present Record..!");
        setValue("allergyType", null);
      } else {
        if (allergyType !== null && allergyType !== undefined) {
          setAllergiesData((pre) => [...pre, obj]);
          setValue("allergyType", null);
          setSelectedAllergie(null);
        } else {
          warningAlert("Please Fill The Record");
        }
      }
    }
  }, [allergyType]);
  const renderInput = (row, index, header) => {
    setValue(`description${index}`, row.Description);
    return (
      <div key={index}>
        {header === "Description" && (
          <>
            <CustomInput
              control={control}
              name={`description${index}`}
              // label="Description"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              inputRef={{
                ...register(`description${index}`, {
                  onChange: (e) => {
                    let tempData = [...allergiesData];
                    tempData[index].description = e.target.value;
                    setAllergiesData(tempData);
                  },
                }),
              }}
            />
          </>
        )}
      </div>
    );
  };

  const handleAllergies = () => {
    getAllergies(null)
      .then((response) => {
        setAllergiesTypeList(response.data.result);
      })
      .catch((response) => {
        console.log(response);
      });
  };

  return (
    <div>
      <div className="flex justify-between items-center bg-[#EDE9FE] rounded-t-md w-full ">
        <div className="">
          <p className="text-sm font-semibold pl-2 ">Allergies</p>
        </div>
        {/* <div className="flex my-auto">
          <button
            type="button"
            onClick={() => {
              setOpenAllergiesModal(true);
              setSave(false);
            }}
          >
            <div className="flex justify-between border w-36 mx-2 bg-white">
              <p className="text-xs my-auto px-2">Allergies</p>
              <SearchIcon />
            </div>
          </button>
        </div> */}

        <div className="w-72 flex">
          {/* <CheckBoxField control={control} name="allergiesYesNo" /> */}
          <fieldset
            onClick={() => {
              handleAllergies();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="w-full"
          >
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              error={errors.allergyType}
              name="allergyType"
              label="Allergies "
              placeholder="Allergies"
              dataArray={allergiesTypeList}
              isSearchable={false}
              handleChange={handleChange}
              onInputChange={handleChange}
              inputRef={{
                ...register("allergyType", {
                  onChange: (e) => {
                    if (e.target.value === "") {
                      // setAllergiesValue(null);
                    } else if (e.target.value !== "") {
                      // setAllergiesValue(e.target.value);
                    }
                  },
                }),
              }}
            />
          </fieldset>
        </div>
      </div>
      <div
        className={` ${
          props.from === "Ent" || props.from === "dental" ? "h-32" : "h-32"
        } border   overflow-auto border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md`}
      >
        <div className="flex justify-between ">
          <div className="flex flex-wrap space-x-2 pl-2">
            {markFavoriteData?.allergy &&
              markFavoriteData?.allergy
                .slice(0, chipsCount)
                .map((item, index) => {
                  const isCheck = allergiesData?.some(
                    (val) => val?.allergy === item.label
                  );
                  return (
                    <>
                      <button
                        type="button"
                        key={index}
                        className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                          allergiesData?.some(
                            (val) => val?.allergy === item.label
                          )
                            ? "bg-[#32819b] text-white rounded-full border"
                            : "text-black rounded-full border"
                        }`}
                        style={{ backgroundColor: item.color, text: "ffffff" }}
                        disabled={allergiesData.some(
                          (val) => val?.allergy === item.label
                        )}
                        onClick={() => {
                          // if (selectedChips.includes(item)) {
                          //   // setSelectedChips(
                          //   //   selectedChips.filter(
                          //   //     (selectedChip) => selectedChip !== item
                          //   //   )
                          //   // );
                          // } else {
                          //   setSelectedChips([...selectedChips, item]);
                          // }
                          setSelectedAllergieDescription("");
                          setSelectedAllergie(item);
                          // setOpenAllergiesModal(true);
                        }}
                      >
                        {item.label}
                      </button>
                      {/* )} */}
                    </>
                  );
                })}
          </div>
        </div>

        {checkDuplicate === true ? (
          <p className="text-xs text-red-500"> Record Already Present</p>
        ) : (
          ""
        )}
        {/* max-h-[12rem] overflow-scroll scrollbar-thin  scrollbar-thumb-blue-200 scrollbar-track-blue-50 */}
        <>
          {allergiesData?.length > 0 ? (
            <div className=" ">
              <CommonTransactionTable
                dataResult={allergiesData.map((row) => ({
                  Allergies: row.allergy,
                  Description: row.description,
                  isNew: row?.isNew,
                }))}
                renderActions={renderAction}
                highlightRow={false}
                removeHeaders={["isNew"]}
                editableColumns={["Description"]}
                renderInput={renderInput}
              />
            </div>
          ) : null}
        </>

        <div className="">
          <AllergiesModal
            allergiesData={allergiesData}
            setAllergiesData={setAllergiesData}
            dataAllergies={dataAllergies}
            setDataAllergies={setDataAllergies}
            openAllergiesModal={
              openAllergiesModal === true ? openAllergiesModal : editOpen
            }
            setOpenAllergiesModal={setOpenAllergiesModal}
            allAllergiesChipsList={allAllergiesChipsList}
            selectedAllergie={selectedAllergie}
            selectedAllergieDecription={selectedAllergieDecription}
            setSelectedChips={setSelectedChips}
            selectedChips={selectedChips}
            data={data}
            setData={setData}
            setEditOpen={setEditOpen}
            edit={edit}
            setEdit={setEdit}
            row={row}
            index={index}
            setSave={setSave}
            save={save}
          />
        </div>
      </div>
    </div>
  );
}

